(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maaeth-orbita-3d"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__maaethOrbit3DV11Installed) return;
  window.__maaethOrbit3DV11Installed = true;

  const instances = new WeakMap();
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const numberValue = (value, fallback = 0) => {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const toRadians = (degrees) => (degrees * Math.PI) / 180;

  const damp = (current, target, sharpness, deltaSeconds) => {
    const amount = 1 - Math.exp(-sharpness * deltaSeconds);
    return current + (target - current) * amount;
  };

  class MaaethOrbit3D {
    constructor(root) {
      this.root = root;
      this.stage = root.querySelector('[data-orbit-stage]');
      this.items = Array.from(root.querySelectorAll('[data-orbit-item]'));

      if (!this.stage || this.items.length < 2) return;

      const initialAngle = toRadians(numberValue(root.dataset.startAngle, 0));

      this.currentAngle = initialAngle;
      this.targetAngle = initialAngle;
      this.angularVelocity = 0;
      this.filteredPointerVelocity = 0;
      this.dragging = false;
      this.totalMovement = 0;
      this.maximumPointerTravel = 0;
      this.suppressNextClick = false;
      this.pointerDownItem = null;
      this.activePointerId = null;
      this.activePointerType = 'mouse';
      this.pointerStartX = 0;
      this.lastPointerX = 0;
      this.lastPointerTime = 0;
      this.lastFrameTime = 0;
      this.animationFrame = null;
      this.snapActive = false;
      this.destroyed = false;
      this.visible = true;
      this.hasInteracted = false;
      this.mobile = false;
      this.lastInteractionTime = Number.NEGATIVE_INFINITY;

      this.reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.dragFactor = numberValue(root.dataset.dragSpeed, 7) * 0.00105;
      this.inertiaPerFrame = numberValue(root.dataset.inertia, 92) / 100;
      this.minimumScale = numberValue(root.dataset.backScale, 68) / 100;
      this.minimumOpacity = numberValue(root.dataset.backOpacity, 65) / 100;
      this.smoothness = numberValue(root.dataset.smoothness, 18);
      this.maximumVelocity = toRadians(
        numberValue(root.dataset.maxSpinSpeed, 480)
      );
      this.depthBlur = numberValue(root.dataset.depthBlur, 0.6);
      this.snapEnabled = root.dataset.enableSnap === 'true';
      this.snapStep = toRadians(numberValue(root.dataset.snapStep, 90));
      this.idleAutoRotate = root.dataset.idleAutoRotate === 'true';
      this.idleAutoSpeedDesktop = -toRadians(
        numberValue(root.dataset.idleAutoSpeedDesktop, 1)
      );
      this.idleAutoSpeedMobile = -toRadians(
        numberValue(root.dataset.idleAutoSpeedMobile, 1)
      );
      this.idleAutoSpeed = this.idleAutoSpeedDesktop;
      this.idleResumeDelay =
        numberValue(root.dataset.idleResumeDelay, 3) * 1000;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerEnd = this.onPointerEnd.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onVisibilityChange = this.onVisibilityChange.bind(this);
      this.tick = this.tick.bind(this);

      this.prepareMedia();
      this.bindEvents();
      this.onResize();
      this.render(this.currentAngle, 0);
      this.requestFrame();
    }

    prepareMedia() {
      this.items.forEach((item) => {
        const wrap = item.querySelector('.maaeth-orbit-3d__model-wrap');
        const media = wrap?.querySelector('model-viewer, img');

        if (!wrap) return;

        if (!media) {
          wrap.classList.add('is-ready');
          return;
        }

        const markReady = () => {
          wrap.classList.remove('has-error');
          wrap.classList.add('is-ready');
        };

        const markError = () => {
          wrap.classList.remove('is-ready');
          wrap.classList.add('has-error');
        };

        media.addEventListener('load', markReady, { once: true });
        media.addEventListener('error', markError, { once: true });

        if (media.tagName === 'IMG' && media.complete) {
          if (media.naturalWidth > 0) markReady();
          else markError();
        }
      });
    }

    bindEvents() {
      this.stage.addEventListener('pointerdown', this.onPointerDown);
      this.stage.addEventListener('pointermove', this.onPointerMove);
      this.stage.addEventListener('pointerup', this.onPointerEnd);
      this.stage.addEventListener('pointercancel', this.onPointerEnd);
      this.stage.addEventListener('lostpointercapture', this.onPointerEnd);
      this.stage.addEventListener('click', this.onClick, true);
      this.stage.addEventListener('keydown', this.onKeyDown);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.stage);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            this.visible = Boolean(entry?.isIntersecting);
            if (this.visible) this.requestFrame();
          },
          { rootMargin: '180px 0px' }
        );
        this.intersectionObserver.observe(this.root);
      }
    }

    onVisibilityChange() {
      if (!document.hidden) this.requestFrame();
    }

    onResize() {
      this.mobile = window.matchMedia('(max-width: 749px)').matches;
      this.idleAutoSpeed = this.mobile
        ? this.idleAutoSpeedMobile
        : this.idleAutoSpeedDesktop;

      this.radiusX = numberValue(
        this.mobile
          ? this.root.dataset.radiusXMobile
          : this.root.dataset.radiusXDesktop,
        this.mobile ? 135 : 300
      );

      this.radiusY = numberValue(
        this.mobile
          ? this.root.dataset.radiusYMobile
          : this.root.dataset.radiusYDesktop,
        this.mobile ? 70 : 110
      );

      this.render(this.currentAngle, performance.now());
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      this.dragging = true;
      this.snapActive = false;
      this.totalMovement = 0;
      this.maximumPointerTravel = 0;
      this.suppressNextClick = false;
      this.pointerDownItem = event.target.closest('[data-orbit-item]');
      this.activePointerId = event.pointerId;
      this.activePointerType = event.pointerType || 'mouse';
      this.pointerStartX = event.clientX;
      this.angularVelocity = 0;
      this.filteredPointerVelocity = 0;
      this.lastPointerX = event.clientX;
      this.lastPointerTime = event.timeStamp || performance.now();
      this.lastInteractionTime = performance.now();
      this.hasInteracted = true;

      this.stage.classList.add('is-dragging');

      try {
        this.stage.setPointerCapture(event.pointerId);
      } catch (_) {
        // Pointer capture isn't complete in every embedded browser.
      }

      this.requestFrame();
    }

    onPointerMove(event) {
      if (!this.dragging) return;

      const coalesced = typeof event.getCoalescedEvents === 'function'
        ? event.getCoalescedEvents()
        : [];
      const samples = coalesced.length > 0 ? coalesced : [event];

      samples.forEach((sample) => {
        const sampleTime = sample.timeStamp || performance.now();
        this.lastInteractionTime = performance.now();
        const deltaX = sample.clientX - this.lastPointerX;
        const deltaSeconds = clamp(
          (sampleTime - this.lastPointerTime) / 1000,
          0.001,
          0.05
        );
        const angleChange = deltaX * this.dragFactor;
        const instantVelocity = angleChange / deltaSeconds;

        this.totalMovement += Math.abs(deltaX);
        this.maximumPointerTravel = Math.max(
          this.maximumPointerTravel,
          Math.abs(sample.clientX - this.pointerStartX)
        );
        this.targetAngle += angleChange;
        this.filteredPointerVelocity =
          this.filteredPointerVelocity * 0.72 + instantVelocity * 0.28;
        this.lastPointerX = sample.clientX;
        this.lastPointerTime = sampleTime;
      });

      this.requestFrame();
    }

    onPointerEnd(event) {
      if (!this.dragging) return;

      const cancelled = event?.type === 'pointercancel';
      const tapThreshold = this.activePointerType === 'mouse' ? 8 : 18;
      const isTap =
        !cancelled &&
        this.maximumPointerTravel <= tapThreshold &&
        this.pointerDownItem &&
        this.pointerDownItem.getAttribute('aria-disabled') !== 'true';

      const tappedItem = isTap ? this.pointerDownItem : null;
      const tappedHref = tappedItem?.getAttribute('href') || '';

      this.dragging = false;
      this.suppressNextClick = !isTap && this.maximumPointerTravel > tapThreshold;
      this.lastInteractionTime = performance.now();
      this.stage.classList.remove('is-dragging');

      if (
        this.activePointerId !== null &&
        this.stage.hasPointerCapture?.(this.activePointerId)
      ) {
        try {
          this.stage.releasePointerCapture(this.activePointerId);
        } catch (_) {
          // Nu toate browserele mobile implementează complet releasePointerCapture.
        }
      }

      this.activePointerId = null;
      this.pointerDownItem = null;

      if (isTap && tappedHref) {
        /*
          Pointer capture poate muta evenimentul click de pe <a> pe stage,
          mai ales în Safari/browser-ele Instagram și TikTok.
          Navigăm explicit după pointerup pentru ca tapul să funcționeze sigur.
        */
        this.suppressNextClick = true;
        window.location.assign(tappedHref);
        return;
      }

      if (this.reducedMotion) {
        this.angularVelocity = 0;
        this.currentAngle = this.targetAngle;
        if (this.snapEnabled) this.startSnap();
        this.render(this.currentAngle, performance.now());
        return;
      }

      this.angularVelocity = clamp(
        this.filteredPointerVelocity * 0.86,
        -this.maximumVelocity,
        this.maximumVelocity
      );

      if (Math.abs(this.angularVelocity) < 0.025 && this.snapEnabled) {
        this.startSnap();
      }

      this.requestFrame();
    }

    onClick(event) {
      const item = event.target.closest('[data-orbit-item]');
      if (!item) return;

      if (
        this.suppressNextClick ||
        item.getAttribute('aria-disabled') === 'true'
      ) {
        event.preventDefault();
        event.stopPropagation();
      }

      this.suppressNextClick = false;
    }

    onKeyDown(event) {
      const step = toRadians(15);

      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        this.hasInteracted = true;
        this.lastInteractionTime = performance.now();
        this.angularVelocity = 0;
        this.snapActive = false;
        this.targetAngle += event.key === 'ArrowLeft' ? -step : step;
        this.requestFrame();
      }

      if (event.key === 'Enter') {
        const frontItem = this.items.reduce((current, item) => {
          const currentDepth = numberValue(current?.dataset.depth, -1);
          const itemDepth = numberValue(item.dataset.depth, -1);
          return itemDepth > currentDepth ? item : current;
        }, null);

        if (frontItem && frontItem.href) {
          window.location.href = frontItem.href;
        }
      }
    }

    shouldIdleRotate(now) {
      return (
        this.idleAutoRotate &&
        !this.reducedMotion &&
        !this.dragging &&
        !this.snapActive &&
        Math.abs(this.angularVelocity) <= 0.004 &&
        now - this.lastInteractionTime >= this.idleResumeDelay
      );
    }

    startSnap() {
      if (!this.snapEnabled) return;
      this.angularVelocity = 0;
      this.snapActive = true;
      this.targetAngle =
        Math.round(this.targetAngle / this.snapStep) * this.snapStep;
    }

    requestFrame() {
      if (this.destroyed || this.animationFrame) return;
      this.animationFrame = requestAnimationFrame(this.tick);
    }

    tick(now) {
      this.animationFrame = null;

      if (this.destroyed || document.hidden) return;
      if (!this.visible && !this.dragging && !this.idleAutoRotate) return;

      const deltaSeconds = this.lastFrameTime
        ? clamp((now - this.lastFrameTime) / 1000, 0.001, 0.05)
        : 1 / 60;
      this.lastFrameTime = now;

      if (!this.dragging) {
        if (Math.abs(this.angularVelocity) > 0.004) {
          this.targetAngle += this.angularVelocity * deltaSeconds;
          this.angularVelocity *= Math.pow(
            this.inertiaPerFrame,
            deltaSeconds * 60
          );

          if (Math.abs(this.angularVelocity) <= 0.004) {
            this.angularVelocity = 0;
            if (this.snapEnabled) this.startSnap();
          }
        } else if (this.shouldIdleRotate(now)) {
          this.targetAngle += this.idleAutoSpeed * deltaSeconds;
        }
      }

      const activeSmoothness = this.dragging
        ? this.smoothness * 1.6
        : this.snapActive
          ? this.smoothness * 0.82
          : this.smoothness;

      this.currentAngle = damp(
        this.currentAngle,
        this.targetAngle,
        activeSmoothness,
        deltaSeconds
      );

      if (
        this.snapActive &&
        Math.abs(this.targetAngle - this.currentAngle) < 0.00045
      ) {
        this.currentAngle = this.targetAngle;
        this.snapActive = false;
      }

      this.render(this.currentAngle, now);

      const stillMoving =
        this.dragging ||
        Math.abs(this.angularVelocity) > 0.004 ||
        Math.abs(this.targetAngle - this.currentAngle) > 0.00045 ||
        this.snapActive ||
        (
          this.idleAutoRotate &&
          !this.reducedMotion
        );

      if (stillMoving) this.requestFrame();
    }

    render(angle, now) {
      if (!this.stage) return;

      let frontItem = null;
      let highestDepth = -1;
      const idleFloat = this.reducedMotion ? 0 : Math.sin(now * 0.0012) * 1.6;

      this.items.forEach((item, index) => {
        const baseAngle = toRadians(numberValue(item.dataset.baseAngle, 0));
        const orbitAngle = angle + baseAngle;
        const rawDepth = (Math.sin(orbitAngle) + 1) / 2;
        const depth = rawDepth * rawDepth * (3 - 2 * rawDepth);

        const x = Math.cos(orbitAngle) * this.radiusX;
        const orbitY = Math.sin(orbitAngle) * this.radiusY;
        const manualY = numberValue(
          this.mobile
            ? item.dataset.offsetYMobile
            : item.dataset.offsetYDesktop,
          0
        );
        const depthScale =
          this.minimumScale + depth * (1 - this.minimumScale);
        const opacity =
          this.minimumOpacity + depth * (1 - this.minimumOpacity);
        const modelSize = numberValue(
          this.mobile
            ? item.dataset.modelSizeMobile
            : item.dataset.modelSizeDesktop,
          1
        );
        const blur = (1 - depth) * this.depthBlur * (this.mobile ? 0.35 : 1);
        const brightness = 0.72 + depth * 0.28;
        const saturation = 0.78 + depth * 0.22;
        const labelOpacity = clamp((depth - 0.18) / 0.72, 0.16, 1);
        const itemFloat = index === 0 ? idleFloat : -idleFloat;

        item.style.transform =
          `translate(-50%, -50%) translate3d(${x.toFixed(3)}px, ` +
          `${(orbitY + manualY + itemFloat).toFixed(3)}px, 0) ` +
          `scale(${depthScale.toFixed(5)})`;
        item.style.zIndex = String(Math.round(100 + depth * 900));
        item.style.setProperty('--maaeth-model-size', modelSize.toFixed(4));
        item.style.setProperty('--maaeth-item-opacity', opacity.toFixed(4));
        item.style.setProperty('--maaeth-item-blur', `${blur.toFixed(3)}px`);
        item.style.setProperty(
          '--maaeth-item-brightness',
          brightness.toFixed(4)
        );
        item.style.setProperty(
          '--maaeth-item-saturation',
          saturation.toFixed(4)
        );
        item.style.setProperty(
          '--maaeth-label-opacity',
          labelOpacity.toFixed(4)
        );
        item.dataset.depth = depth.toFixed(5);

        if (depth > highestDepth) {
          highestDepth = depth;
          frontItem = item;
        }
      });

      this.items.forEach((item) => {
        const isFront = item === frontItem && highestDepth > 0.62;
        item.classList.toggle('is-front', isFront);

        if (isFront) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
    }

    destroy() {
      this.destroyed = true;

      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }

      this.stage.removeEventListener('pointerdown', this.onPointerDown);
      this.stage.removeEventListener('pointermove', this.onPointerMove);
      this.stage.removeEventListener('pointerup', this.onPointerEnd);
      this.stage.removeEventListener('pointercancel', this.onPointerEnd);
      this.stage.removeEventListener('lostpointercapture', this.onPointerEnd);
      this.stage.removeEventListener('click', this.onClick, true);
      this.stage.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);

      if (this.resizeObserver) this.resizeObserver.disconnect();
      else window.removeEventListener('resize', this.onResize);

      if (this.intersectionObserver) this.intersectionObserver.disconnect();
    }
  }

  const initialize = (scope = document) => {
    const roots = [];

    if (scope.matches?.('[data-maaeth-orbit-3d]')) roots.push(scope);
    roots.push(...scope.querySelectorAll('[data-maaeth-orbit-3d]'));

    roots.forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new MaaethOrbit3D(root));
    });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.('[data-maaeth-orbit-3d]')
      ? event.target
      : event.target.querySelector('[data-maaeth-orbit-3d]');
    const instance = root ? instances.get(root) : null;

    if (instance) {
      instance.destroy();
      instances.delete(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
